var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionGreybg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Need_Help_",
    "data-name": "Need Help?",
    transform: "translate(-107 -162.549)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14191",
    "data-name": "Rectangle 14191",
    width: 52,
    height: 52,
    transform: "translate(107 162.549)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-help",
    d: "M15,3A12,12,0,1,0,27,15,12,12,0,0,0,15,3Zm0,19.5A1.5,1.5,0,1,1,16.5,21,1.5,1.5,0,0,1,15,22.5Zm2.068-7C16.406,16.111,16,16.512,16,17H14a4.09,4.09,0,0,1,1.711-2.97C16.51,13.292,17,12.8,17,12a2,2,0,0,0-4,0H11a4,4,0,0,1,8,0A4.651,4.651,0,0,1,17.068,15.5Z",
    transform: "translate(119 174.5)",
    fill: "#533ffb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionGreybg);
export default __webpack_public_path__ + "static/media/question-greybg.b1790c3a5b7a763f25b6aada24140ec5.svg";
export { ForwardRef as ReactComponent };